import * as Yup from 'yup'

const isEmpty = value => {
  return value.trim().length === 0
}

// const zipcodeBelongsToAllZipcodes = value => {
//   const { allZipcodes } = this.props
//   const zipcode = value.trim()
//   const postcodeBelongsToAllZipcodes = allZipcodes.find(vz => zipcode === vz)

//   return !!postcodeBelongsToAllZipcodes
// }

// const zipcodeIsValid = value => {
//   const { validZipcodes, allZipcodes } = this.props
//   const zipcode = value.trim()
//   const postcodeBelongsToValidZipcodes = validZipcodes.find(
//     vz => zipcode === vz
//   )
//   const postcodeBelongsToAllZipcodes = allZipcodes.find(vz => zipcode === vz)

//   return !(!postcodeBelongsToValidZipcodes && !!postcodeBelongsToAllZipcodes)
// }

export const validationSchema =  Yup.object().shape({
  city: Yup.string().test(
    'is-empty',
    'Required',
    value => value && !isEmpty(value)
  ),
  zipcode: Yup.string().test(
    'is-empty',
    'Required',
    value => value && !isEmpty(value)
  ),
  // .test(
  //   'is-valid-zipcode',
  //   'Please use an address with a valid delivery zone zipcode',
  //   value => value && zipcodeBelongsToAllZipcodes(value)
  // )
  // .test(
  //   'is-out-of-delivery-zone',
  //   'Please use an address within your delivery zone or contact customer support',
  //   value => value && zipcodeIsValid(value)
  // ),
  street: Yup.string().test(
    'is-empty',
    'Required',
    value => value && !isEmpty(value)
  ),
  floor: Yup.string(),
  state: Yup.string().test(
    'is-empty',
    'Required',
    value => value && !isEmpty(value)
  ),
  phone: Yup.string().test(
    'is-empty',
    'Required',
    value => value && !isEmpty(value)
  ),
  is_default: Yup.boolean()
})

export const phoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]



// WEBPACK FOOTER //
// ./src/modules/Checkout/DeliveryDetails/utils.js